import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { DISCLAIMER } from "@/lib/constants";

// Shared shell for auth pages (login/register/forgot/reset).
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#F7F7F2]">
      <div className="flex h-1 w-full" aria-hidden="true">
        <div className="flex-1" style={{ background: "#FF9933" }} />
        <div className="flex-1 bg-white" />
        <div className="flex-1" style={{ background: "#138808" }} />
      </div>
      <div className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-6 flex flex-col items-center gap-2" data-testid="auth-logo">
            <Logo size={52} />
            <span className="font-serif text-xl font-bold text-[#0B2545]">UPSC With Arpita</span>
          </Link>
          <div className="gov-card overflow-hidden">
            <div className="gov-card-header px-5 py-3 text-center font-serif text-lg font-bold">{title}</div>
            <div className="p-6">
              {subtitle && <p className="mb-4 text-center text-sm text-gray-600">{subtitle}</p>}
              {children}
            </div>
          </div>
          {footer && <div className="mt-4 text-center text-sm text-gray-600">{footer}</div>}
          <p className="mt-6 text-center text-[11px] leading-relaxed text-gray-400">{DISCLAIMER}</p>
        </div>
      </div>
    </div>
  );
}

export function GoogleButton({ testId = "google-btn", next }) {
  const onClick = () => {
    if (next) sessionStorage.setItem("postAuthNext", next);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={onClick} className="flex w-full items-center justify-center gap-2 rounded-sm border border-[#D1D5DB] bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50" data-testid={testId}>
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4" />
      Continue with Google
    </button>
  );
}
